module.exports = __webpack_public_path__ + "media/images/logo_landing_page-f3a4986c04400d72ee7049c9f119a2b1.png";